// libraries
import type { StateTree, DeskingGlobalState } from '@makemydeal/dr-dash-types';

export const getDeskingGlobalState = (state: StateTree): DeskingGlobalState => {
    return state.deskingGlobal || {};
};

export const getPaymentDetailsAccordionExpanded = (state: StateTree): boolean => {
    return getDeskingGlobalState(state).paymentDetailsAccordionExpanded || false;
};

export const getTaxesAccordionExpanded = (state: StateTree): boolean => {
    return getDeskingGlobalState(state).taxesAccordionExpanded || false;
};

export const getFeesAccordionExpanded = (state: StateTree): boolean => {
    return getDeskingGlobalState(state).feesAccordionExpanded || false;
};

export const getLienholderAccordionExpanded = (state: StateTree): boolean => {
    return getDeskingGlobalState(state).lienholderAccordionExpanded || false;
};

export const isProgramsSlideOutOpen = (state: StateTree): boolean => {
    return getDeskingGlobalState(state).isProgramsSlideOutOpen || false;
};

export const isAccessoriesCatalogSlideOutOpen = (state: StateTree): boolean => {
    return getDeskingGlobalState(state).isAccessoriesCatalogSlideOutOpen || false;
};

export const isCreditDecisionSlideOutOpen = (state: StateTree): boolean => {
    return getDeskingGlobalState(state).isCreditDecisionSlideOutOpen || false;
};

export const getDealTypeOverrideReason = (state: StateTree): string | null => {
    return getDeskingGlobalState(state).dealTypeOverrideReason || null;
};

export const getProgramsSlideOutPreviousCalcEndpoint = (state: StateTree): string | null => {
    return getDeskingGlobalState(state).programsSlideOutPreviousCalcEndpoint || null;
};

export const getProgramsSlideOutPreviousOfferType = (state: StateTree): string | null => {
    return getDeskingGlobalState(state).programsSlideOutPreviousOfferType || null;
};
